import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TopBanner from './components/TopBanner';
import ComparisonTable from './components/ComparisonTable';
import ContentSections from './components/ContentSections';
import CryptoSection from './components/CryptoSection';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import EmailSignup from './components/EmailSignup';
import EmailPopup from './components/EmailPopup';
import StickyMobileCTA from './components/StickyMobileCTA';
import Footer from './components/Footer';
import { faqItems } from '../../mocks/services';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://remesasve.com';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'RemesasVE',
  url: siteUrl,
  description: 'Comparador gratuito de servicios de remesas a Venezuela. Compara tasas, comisiones y tiempos de envío de Wise, Remitly, Western Union y más.',
  inLanguage: 'es',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/#comparar`,
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'RemesasVE – La Mejor Forma de Enviar Dinero a Venezuela',
  url: siteUrl,
  description:
    'Compara los mejores servicios para enviar dinero a Venezuela: tasas de cambio, comisiones y tiempo de envío de Wise, Remitly, Western Union y WorldRemit. Gratis y actualizado diariamente.',
  inLanguage: 'es',
  isPartOf: { '@type': 'WebSite', name: 'RemesasVE', url: siteUrl },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Inicio', item: siteUrl }],
  },
};

const financialServiceSchema = {
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  name: 'RemesasVE – Comparador de Remesas a Venezuela',
  url: siteUrl,
  description:
    'Herramienta gratuita para comparar los mejores servicios de envío de dinero a Venezuela. Encuentra la mejor tasa de cambio y menor comisión entre Wise, Remitly, Western Union y WorldRemit.',
  inLanguage: 'es',
  areaServed: { '@type': 'Country', name: 'Venezuela' },
  audience: { '@type': 'Audience', audienceType: 'Venezolanos en el exterior' },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Home() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen font-sans">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(financialServiceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <EmailPopup />
      <StickyMobileCTA />
      <Navbar />
      <Hero
        onCompare={() => scrollTo('comparar')}
        onHowItWorks={() => scrollTo('como-funciona')}
      />
      <TopBanner />
      <ComparisonTable />
      <ContentSections />
      <CryptoSection />
      <HowItWorks />
      <FAQ />
      <EmailSignup />
      <Footer />
    </div>
  );
}
